/**
 * @generated SignedSource<<0f4994f7404ad4dce9b78907955a457e>>
 * @relayHash a4ea1e3a1f82018e1b2573eb3ab0c960
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3eafd244677c3eef60ca87351c634188cdc54c53ecb4fe42d6f05522ace35a66

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isBusinessStatusMappingEnabled_provider from '@atlassian/jira-relay-provider/src/allow-status-mapping-on-business-board.relayprovider';
import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';
import isBusinessRelayBoardWorkflowEditingEnabled_provider from '@atlassian/jira-relay-provider/src/relay-board-workflow-editing.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3eafd244677c3eef60ca87351c634188cdc54c53ecb4fe42d6f05522ace35a66",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelayboardworkfloweditingrelayprovider": isBusinessRelayBoardWorkflowEditingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
